export default __webpack_public_path__ + "static/media/NEW_outdoor_pic.f3a803ad.jpeg";